import React from "react";
import { Link } from "gatsby";
import Img01 from "../../images/advice-img.jpg"
import "./Advice.scss";
import { PageLinks } from "../../common/page-links";

const Advice = () => {


    return (
        <React.Fragment>
            <section className="advice">
                <div className="advice-wrap">
                    <div className="img-wrap">
                        <img src={Img01} alt="advice" />
                    </div>
                    <div className="advice-content">
                        <div className="h4">
                            Need mortgage advice or help finding the best deal?
                            <span className="sm-text"> We’ve got a team
                                of experts ready to help.</span> <Link to={`/${PageLinks.financial_services}/`} className="speak-us d-block d-md-inline-block d-lg-inline-block">Speak with our broker</Link>
                        </div>
                    </div>
                </div>

            </section>
        </React.Fragment>
    );
};
export default Advice;
